module.exports = __webpack_public_path__ + "static/img/jiqiren_01.832710d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/jiqiren_01.png
// module id = NQ/K
// module chunks = 0